import { Component, Input } from '@angular/core';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { CourseContentType } from '../../shared/types/course-content-type';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { PracticeSectionContent } from '../practice-section/practice-section.interface';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  COMMON_EXPRESSIONS_MODAL_TITLE_ID,
  CommonExpressionsModalComponent,
} from '../common-expressions-modal/common-expressions-modal.component';
import { ImmersionTileModalData } from '../immersion-tile/immersion-tile-modal-data';

@Component({
  selector: 'lp2-idiom-carousel',
  templateUrl: './idiom-carousel.component.html',
  styleUrls: ['./idiom-carousel.component.scss'],
})
export class IdiomCarouselComponent extends ImmersionCarouselComponent implements PracticeSectionContent {
  get shouldDisplay$() {
    return this.itemsLoaded$.pipe(map((hasLoaded) => hasLoaded && !this.isMobile && (this.immersionItems.length > 0 || this.hasError)));
  }

  @Input()
  isMobile: boolean;

  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.idiomsPoints = value
      ? value.get(GamificationActivityType.COMPLETE_PRACTICE_COMMON_EXPRESSION)
      : 0;
  }

  idiomsPoints: number;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  readonly modalComponent = CommonExpressionsModalComponent;
  readonly modalData: ImmersionTileModalData = { showCloseButton: false };
  readonly modalTitleId = COMMON_EXPRESSIONS_MODAL_TITLE_ID;

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService
  ) {
    super(service, levelProgressService, CourseContentType.IDIOMS);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/idiom-carousel/idiom-carousel.component.ts